interface GetVanityFacetValues {
	[key: string]: { minInput: string; maxInput: string };
}

export const getVanityFacetValues: GetVanityFacetValues = {
	'REC-inexpensive': { minInput: '', maxInput: '2500' },
	'REC-affordable': { minInput: '2500', maxInput: '5000' },
	'REC-luxury': { minInput: '10000', maxInput: '' },
	'WPH-affordable': { minInput: '', maxInput: '1000' },
	'VID-affordable': { minInput: '', maxInput: '1500' },
	'VID-luxury': { minInput: '2500', maxInput: '' },
	'FLO-affordable': { minInput: '1000', maxInput: '1999' },
};

// Vanity facet labels for display in filter pills
export const vanityFacetLabels: Record<string, string> = {
	'REC-inexpensive': '$ – Inexpensive',
	'REC-affordable': '$$ – Affordable',
	'REC-luxury': '$$$ – Luxury',
	'WPH-affordable': '$$ – Affordable',
	'VID-affordable': '$$ – Affordable',
	'VID-luxury': '$$$ – Luxury',
	'FLO-affordable': '$$ – Affordable',
	// Fallback labels without category prefix
	inexpensive: '$ – Inexpensive',
	affordable: '$$ – Affordable',
	luxury: '$$$ – Luxury',
};

/**
 * Maps category+vanitySlug to facet IDs used in searchFacetSeoText.ts
 * These IDs are needed for the seoFilter() function to match and return SEO text
 */
export const vanitySlugToFacetId: Record<string, string> = {
	'REC-inexpensive': '7dd029e6-1879-4381-81b9-5dc4998fbdec',
	'REC-affordable': '82d0bc5a-8269-4b3b-ba2f-ba833f9c0fe2',
	'REC-luxury': '3a18c67f-f9ac-4ff9-80b8-61ed88bc4cd1',
	'WPH-affordable': 'bf895e5e-585b-4b5b-b8c9-e1cc0331dee6',
	'VID-affordable': '82d0bc5a-8269-4b3b-ba2f-ba833f9c0fe2',
	'VID-luxury': '3a18c67f-f9ac-4ff9-80b8-61ed88bc4cd1',
	'FLO-affordable': '82d0bc5a-8269-4b3b-ba2f-ba833f9c0fe2',
};

export const getRangesByCategory = (categoryCode: string) => {
	switch (categoryCode) {
		case 'FLO':
			return [0, 4000, 250];
		case 'VID':
			return [0, 4000, 250];
		case 'WPH':
			return [0, 5000, 250];
		case 'PLN':
			return [0, 5000, 250];
		case 'BEA':
			return [0, 1000, 250];
		case 'DJS':
			return [0, 2500, 250];
		case 'CAT':
			return [0, 4000, 250];
		case 'BAR':
			return [0, 1500, 250];
		case 'SPV':
			return [0, 5000, 250];
		case 'OPC':
			return [0, 500, 250];
		case 'PHB':
			return [0, 1000, 250];
		case 'BDS':
			return [0, 8500, 250];
		case 'BWP':
			return [0, 2000, 250];
		case 'WCK':
			return [0, 500, 250];
		case 'RNT':
			return [0, 1500, 250];
		case 'TRA':
			return [0, 1000, 250];
		case 'ENS':
			return [0, 1000, 250];
		case 'DNC':
			return [0, 500, 250];
		case 'FAV':
			return [0, 1500, 250];
		case 'DEC':
			return [0, 4000, 250];
		case 'TRV':
			return [0, 5000, 250];
		case 'JWL':
			return [0, 1500, 250];
		case 'INV':
			return [0, 2500, 250];
		default:
			return [0, 20000, 500];
	}
};

const pricingCombos = [
	'REC-inexpensive',
	'REC-affordable',
	'REC-luxury',
	'WPH-affordable',
	'VID-affordable',
	'VID-luxury',
	'FLO-affordable',
];

export const determineIsVanityFacet = (
	categoryCode: string,
	applied: { key: string; value: string }[],
) => {
	const appliedValue = applied.length === 1 ? applied[0].value : '';
	return pricingCombos.includes(`${categoryCode}-${appliedValue}`);
};
